import moment from "moment";
import { findSkipDay, isDayInCurrentMonth, shouldDisableDate } from "./dateTimeUtils";
import { alpha, useTheme } from "@mui/material";
import { useGetContrastColor } from "../../hooks/useGetContrastColor";
export const useSkipDaysPickerValues = (allSkipDays, badgeProps, currentMonth, day, daysForCurrentMonth) => {
    var _a, _b, _c, _d;
    const theme = useTheme();
    const daysInMonth = currentMonth ? currentMonth.days : daysForCurrentMonth;
    const isDisabledDay = (_a = shouldDisableDate(day, allSkipDays)) !== null && _a !== void 0 ? _a : false;
    const isInCurrentMonth = (_b = isDayInCurrentMonth(day, daysInMonth)) !== null && _b !== void 0 ? _b : false;
    const isSkipDay = (_c = findSkipDay(day, daysInMonth)) !== null && _c !== void 0 ? _c : false;
    const targetDay = (_d = daysInMonth === null || daysInMonth === void 0 ? void 0 : daysInMonth.find((skipDay) => day.isSame(skipDay.customerDate, "day"))) !== null && _d !== void 0 ? _d : moment();
    const primaryColorLight = theme.palette.primary.light;
    const selectedBackgroundColor = alpha(primaryColorLight, 0.1);
    const selectedTextColor = useGetContrastColor(selectedBackgroundColor);
    const updatedBadgeProps = Object.assign(Object.assign({}, badgeProps), { invisible: !!isSkipDay || !isInCurrentMonth || isDisabledDay || !!(targetDay && !targetDay.hasMealsAssigned) });
    return {
        isDisabledDay,
        isInCurrentMonth,
        isSkipDay,
        selectedBackgroundColor,
        selectedTextColor,
        targetDay,
        updatedBadgeProps,
    };
};
